/**
 * STATUSES ALLOWED ONLY when userProcess.mode === "POST"
 */
export const UserProcessStatus_POST = {
  /**
   * ### Status set by system (POST 1 only)
   * - AFTER the consultant confirms: "I have reviewed the personal-data and documents"
   * - AND AFTER documents(main application, statements, checklist) have been generated succesfully.
   * ### Requirements
   * - `userProcess.mode === "POST"` AND `userProcess.hasAssistantService === false && userProcess.hasFullHandling === false`
   * ### What Foreigner sees:
   *  - instructions how to submit the documents by post to the voivo-office
   *  - option to upload documents for final-review
   *
   * ### This is the end of the process for such user-processes.
   */
  REVIEW_DONE_POST_SUBMISSION_INSTRUCTIONS: 'REVIEW_DONE_POST_SUBMISSION_INSTRUCTIONS',

  /**
   * ### Status set by system (POST 3 only)
   * - (POST 3) AFTER the consultant confirms: "I have reviewed the personal-data and documents"
   * - (POST 3) AND AFTER documents(main application, statements, checklist) have been generated succesfully.
   * ### Requirements
   * - `userProcess.mode === "POST"` AND `userProcess.hasFullHandling === true`
   * ### What Foreigner sees:
   *  - Foreigner SEES ONLY information that now he has to select how he will provide us/sign the documents that we prepared for him.
   *    - He sees the radio group that we already have: "I will come to the office to sign the documents" OR "I will sign the documents and send them by post"
   */
  SELECTING_DOCUMENTS_SIGN_MODE: 'SELECTING_DOCUMENTS_SIGN_MODE',

  /**
   * ### Status set by system (POST 3 only)
   * - (POST 3) AFTER the FOREIGNER selected: "I will sign the documents and send them by post" in previous step
   * ### Requirements
   * - `userProcess.mode === "POST"` AND `userProcess.hasFullHandling === true`
   * ### What Foreigner sees:
   * - Address of the office where to send the documents by post (with any extra information about the recipient)
   * - REQUIRED List of documents that should be in the package (Main application signed 2x, PoA signed 2x, statements signed 1x etc.)
   * - NEW! BUTTON To confirm "I confirm sending the documents"
   * - Option to change the way of providing/signing the documents (go back to previous step)`
   * - Information about list of required documents (Checklist) that will be needed later for the voivo-office visit
   */
  SENDING_DOCS_TO_OFFICE_BY_POST: 'SENDING_DOCS_TO_OFFICE_BY_POST',

  /**
   * ### Status set by system (POST 3 only)
   * - (POST 3) AFTER the FOREIGNER confirmed with button: "I confirm sending the documents" in previous step
   * ### Requirements
   * - `userProcess.mode === "POST"` AND `userProcess.hasFullHandling === true`
   * ### What Foreigner sees:
   * - Thank you for sending the documents to: [repeated address of the office just in case]\
   * - You can still change the way of providing/signing the documents (button which will show the selection options again)`
   * - We will inform you when we receive the documents in our office. After ensuring everything is verified, we will send them to the voivo-office (immigration office)
   * - Information about list of required documents (Checklist) that will be needed later for the voivo-office visit
   * - Option to upload documents for final-review
   */
  DOCUMENTS_SENT_TO_OFFICE_BY_POST: 'DOCUMENTS_SENT_TO_OFFICE_BY_POST',

  /**
   * ### Status set by system (POST 3 only)
   * - (POST 3) AFTER the CONSULTANT (EMPLOYEE) confirmed with button: "I confirm receiving the documents"
   * ### Requirements
   * - `userProcess.mode === "POST"` AND `userProcess.hasFullHandling === true`
   * ### What Foreigner sees:
   * - We have received the documents in our office. Thank you for sending them to us.
   * - Please wait for our confirmation that we have verified the documents and sent them to the voivo-office (immigration office). We will inform you about it immediately.
   * - Information about list of required documents (Checklist) that will be needed later for the voivo-office visit
   * - Option to upload documents for final-review
   */
  SIGNED_DOCUMENTS_RECEIVED: 'SIGNED_DOCUMENTS_RECEIVED',

  /**
   * ### Status set by system (POST 3 only)
   * - (POST 3) AFTER the FOREIGNER selected: "I will come to the office" AND selected date for the appointment in previous step
   * ### Requirements
   * - `userProcess.mode === "POST"` AND `userProcess.hasFullHandling === true`
   * ### What Foreigner sees:
   * - Appointment date and time and status (requested/confirmed/rejected) with the possibility to change it (go back to previous step)
   * - REQUIRED documents to be printed: Main Requeste Document, PoA, Statements
   * - Information about list of required documents (Checklist) that will be needed later for the voivo-office visit
   */
  APPOINTMENT_TO_SIGN_DOCS: 'APPOINTMENT_TO_SIGN_DOCS',

  /**
   * ### Status set by system (POST 3 only)
   * - (POST 3) AFTER the CONSULTANT (EMPLOYEE) CONFIRMED: "I confirm sending the documents to the voivo-office (immigraiton office)" in previous step
   * ### Requirements
   * - `userProcess.mode === "POST"` AND `userProcess.hasFullHandling === true`
   * ### What Foreigner sees:
   * - Information: We have sent the documents to the voivo-office (immigration office). We will inform you about the appointment date for the visit to the voivo-office (immigration office) immediately after we receive it from them.
   * - REQUIRED List of required documents (checklist) that foreigner must have prepared for the voivo-office
   * - Option to upload documents for final-review
   */
  AWAITING_IMMIGROF_VISIT_INFO__FROM_IMMIGROF: 'AWAITING_IMMIGROF_VISIT_INFO__FROM_IMMIGROF',

  /**
   * ### Status set by system
   * - (POST 3) AFTER the CONSULTANT (EMPLOYEE) entered the date of the visit in the voivo-office (immigration office) when he (our office) received that information from the voivo-office (immigration office)
   * ### Requirements
   * - `userProcess.mode === "POST" AND userProcess.hasAssistantService === true && userProcess.hasFullHandling === true`
   * ### What Foreigner sees:
   * - (POST 3) All see same stuff:
   *  - Date of the visit & address of the immigration office where the visit is taking place.
   *  - Instructions to prepare documents from the LIST OF REQUIRED DOCUMENTS (checklist) + POWER OF ATTORNEY (If needed)
   *  - Option to upload documents for final-review
   * -  Printing Main Request Form + Statements (as optional because these are not needed now)
   */
  IMMIGROF_VISIT_SCHEDULED: 'IMMIGROF_VISIT_SCHEDULED',
} as const;
export type UserProcessStatus_POST = (typeof UserProcessStatus_POST)[keyof typeof UserProcessStatus_POST];
